'use client';
import Image from 'next/image';

const Infobox = ({ boxes, buttonText }) => {
  return (
    <div>
      <section className="py-10">
        <div className="max-w-screen-2xl mx-5 lg:mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3 -mt-28">
            {boxes.map((box, index) => (
              <div
                key={index}
                className="bg-white rounded-lg p-5 border h-full flex flex-col justify-between z-10"
              >
                <div className="flex items-center justify-between mb-3">
                  <h6 className="font-bold h-10">{box.title}</h6>
                  <div className="w-12 h-12 flex items-center justify-center">
                    <Image
                      src={box.img}
                      width={50}
                      height={50}
                      alt={box.title}
                      className="text-green-500"
                      style={{
                        filter:
                          'invert(25%) sepia(92%) saturate(429%) hue-rotate(95deg) brightness(94%) contrast(85%)',
                      }}
                    />
                  </div>
                </div>
                <p className="flex-grow">{box.description}</p>
                <div className="flex items-center justify-between mt-4">
                  <button className="text-xs bg-blue-600 text-white px-3 py-1 rounded-lg">
                    {buttonText}
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Infobox;
